module.exports = __webpack_public_path__ + "img/especialista33.3cfe8c5b.png";